import { 
  L10nService, 
  type Localizations, 
  type Translator } from "~/service/l10n";

export type MapL10nResources = {
  translations: Localizations;
}

export type MapL10n = MapL10nResources & {
  tranlator: Translator
}

const modules = import.meta.glob('./l10n/l10n_*.ts');


export async function loadTranslator(locale: string): Promise<MapL10n> {
  const file = `./l10n/l10n_${locale}.ts`;
  const resources = await modules[file]() as MapL10nResources;
  const l10n: MapL10n = { ...resources, tranlator: L10nService.toTranslator(locale, resources.translations) }
  return l10n;
}
